import { css } from '@linaria/atomic';
import { useTranslation } from '@frontend/i18n';
import { ContainedIcon } from '@frontend/icons';
import { Photos } from '@frontend/photos';
import { AiAssistant } from '@frontend/styled-icons';
import { theme } from '@frontend/theme';
import { Truncated, Text } from '@frontend/design-system';

const aiOfficeUserRoutedPhotosContactProfilePhotoStyle1 = css`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
`;

export const AiOfficeUserRouted = ({ name, userId }: { name?: string; userId?: string }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'grid',
        alignItems: 'center',
        gridAutoFlow: 'column',
        gap: theme.spacing(0.5),
      }}
    >
      <AiAssistant />
      <ContainedIcon iconName='caret-right' size={12} />
      {userId && (
        <Photos.ContactProfilePhoto
          personId={userId ?? ''}
          // Only show the first initial since this is a small avatar
          name={name ? name.split(' ')[0] : undefined}
          title={name}
          disableClick={true}
          size='small'
          className={aiOfficeUserRoutedPhotosContactProfilePhotoStyle1}
        />
      )}
      <Truncated as={Text} size='medium' color='default'>
        {name ?? t('Office User')}
      </Truncated>
    </div>
  );
};

export const AiOfficeUser = ({
  fontSize,
  fontWeight,
  style,
}: {
  fontSize?: React.CSSProperties['fontSize'];
  fontWeight?: React.CSSProperties['fontWeight'];
  style?: React.CSSProperties;
}) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'grid',
        alignItems: 'center',
        gridAutoFlow: 'column',
        gap: theme.spacing(0.5),
        ...style,
      }}
    >
      <AiAssistant />
      <Truncated as={Text} size='medium' color='default' style={{ fontSize, fontWeight }}>
        {t('AI Receptionist')}
      </Truncated>
    </div>
  );
};
